import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, TransitionGroup as _TransitionGroup, toHandlers as _toHandlers, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "package-card--title" }
const _hoisted_2 = { class: "w-100 package-category-wrapper" }
const _hoisted_3 = { class: "pt-4 mb-4 card-padding-x package-category-searchbar" }
const _hoisted_4 = { class: "package-category" }
const _hoisted_5 = { class: "package-categories-list" }
const _hoisted_6 = ["data-index"]
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { class: "plans-list pt-4 pb-5" }
const _hoisted_9 = { class: "card-padding-x" }
const _hoisted_10 = {
  key: 0,
  class: "card-padding-x packages-empty"
}
const _hoisted_11 = {
  key: 0,
  class: "card-padding-x packages-empty"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", { class: "secondary-text sm mb-5" }, "There are no packages added to this plan yet.", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "card-padding-x pb-4 mb-2 package-categories-list__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTabsHead = _resolveComponent("AppTabsHead")!
  const _component_SearchControl = _resolveComponent("SearchControl")!
  const _component_EsimPackageCard = _resolveComponent("EsimPackageCard")!
  const _component_InlineAccordion = _resolveComponent("InlineAccordion")!
  const _component_tab_panel = _resolveComponent("tab-panel")!
  const _component_AppTabsBody = _resolveComponent("AppTabsBody")!
  const _component_CustomScrollbar = _resolveComponent("CustomScrollbar")!
  const _component_BtnContent = _resolveComponent("BtnContent")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    "tabs-title": _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    tabs: _withCtx(() => [
      _createVNode(_component_AppTabsHead, {
        modelValue: _ctx.selectedTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTab) = $event)),
        tabs: _ctx.tabs,
        margin: true
      }, null, 8, ["modelValue", "tabs"])
    ]),
    "tabs-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_CustomScrollbar, { "max-height": 400 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_SearchControl, {
                  "on-search": () => {},
                  name: "package-search",
                  "field-type": "inline-field",
                  placeholder: "search",
                  disabled: _ctx.getEmptyData,
                  onSearch: _ctx.searchHandler
                }, null, 8, ["on-search", "disabled", "onSearch"])
              ]),
              _createVNode(_component_AppTabsBody, {
                "selected-tab-idx": _ctx.selectedTab,
                animate: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packagesArray, ([purchaseType, validityTypes], idx) => {
                    return (_openBlock(), _createBlock(_component_tab_panel, {
                      key: purchaseType,
                      val: _ctx.tabs[idx]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_TransitionGroup, _mergeProps({ tag: "ul" }, _toHandlers(_ctx.transition)), {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validityTypes, ({ validityName, opened, $packages }, idx) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: validityName,
                                      class: "package-categories-list--item w-100",
                                      style: {"will-change":"height"},
                                      "data-index": idx
                                    }, [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_InlineAccordion, {
                                          "initial-opened": opened,
                                          "heading-inner-classnames": "card-padding-x",
                                          onOpen: ($event: any) => (
                                _ctx.packageCategoriesAccordionHandler(validityName)
                              ),
                                          onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.packageCategoriesAccordionHandler('-1')))
                                        }, {
                                          header: _withCtx(() => [
                                            _createElementVNode("strong", null, [
                                              _createElementVNode("b", null, _toDisplayString(validityName), 1)
                                            ])
                                          ]),
                                          content: _withCtx(() => [
                                            _createElementVNode("ul", _hoisted_8, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($packages, ({ title, id, editData }, idx) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                  key: title,
                                                  class: _normalizeClass(["plans-list-item", {
                                      'mt-2': idx > 0
                                    }]),
                                                  style: _normalizeStyle({
                                      position: 'relative',
                                      zIndex: idx + 1
                                    })
                                                }, [
                                                  _createElementVNode("div", _hoisted_9, [
                                                    _createVNode(_component_EsimPackageCard, {
                                                      id: id,
                                                      title: title,
                                                      onEdit: ($event: any) => (_ctx.packageEdit(editData)),
                                                      onDelete: ($event: any) => (_ctx.packageDelete(id))
                                                    }, null, 8, ["id", "title", "onEdit", "onDelete"])
                                                  ])
                                                ], 6))
                                              }), 128))
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["initial-opened", "onOpen"])
                                      ])
                                    ], 8, _hoisted_6))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1040)
                            ])
                          ])
                        ]),
                        (!validityTypes.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("strong", {
                                class: _normalizeClass(["secondary-text sm mb-2", {
                      'mt-3': !validityTypes.length && !_ctx.searchQuery.length
                    }])
                              }, "There are no packages added to this plan yet.", 2)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["val"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["selected-tab-idx"])
            ]),
            _: 1
          })
        ]),
        (_ctx.getEmptyData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_AppButton, {
            size: "xl",
            type: "primary-border-dashed",
            onClick: _ctx.packageAdd
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BtnContent, {
                icon: "plus",
                label: "Add Package"
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}